import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/frontend/components/layouts/provider-component.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/html/frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/var/www/html/frontend/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/var/www/html/frontend/node_modules/next/font/google/target.css?{\"path\":\"app/not-found.tsx\",\"import\":\"Nunito\",\"arguments\":[{\"weight\":[\"400\",\"500\",\"600\",\"700\",\"800\"],\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-nunito\"}],\"variableName\":\"nunito\"}");
